import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    templateUrl: './terms-and-conditions-modal.component.html'
})
export class TermsAndConditionsModalComponent implements OnInit {
    public form!: FormGroup;
    public formSubmitted: boolean = false;
    
    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: FormBuilder,
    ) { }

    ngOnInit() {
        this.form = this.formBuilder.group({
			check: new FormControl(false, [Validators.required, Validators.requiredTrue]),
		});
    }

    public formSubmit(): void {
        this.activeModal.close(true);
    }
}
